import React from 'react';
import Box, { BoxProps } from '@mui/material/Box';
import Typography from '@mui/material/Typography';

interface HeaderTitleProps extends BoxProps {
  title: string;
}

const HeaderTitle: React.FC<HeaderTitleProps> = ({ title, sx, ...boxProps }) => (
  <Box sx={{ mt: '0px', mb: '0px', ...sx }} {...boxProps}>
    <Typography
      component="h1"
      sx={{
        fontFamily: 'Inter, sans-serif',
        fontWeight: 700,
        fontStyle: 'normal',
        fontSize: '24px',
        lineHeight: '1.3',
        letterSpacing: 0,
      }}
    >
      {title}
    </Typography>
  </Box>
);

export default HeaderTitle;